import jQuery from '@/js/front/jquery';
import { addToCart } from '@/js/front/add-to-cart';

jQuery( () => {
    /**
     * Add an event listener for add-to-cart buttons.
     */
	const setupAddToCartEventListener = () => {
		document.addEventListener( 'click', ( event ) => {
			const target = event.target;

			if ( ! target.matches( '.single_add_to_cart_button:not(.disabled)' ) ) {
				return;
			}

			event.preventDefault();

			const cartForm = target.closest( 'form.cart' );

			addToCart( target, cartForm );
		} );
	}
	
	setupAddToCartEventListener();
} );
